/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/file_txt_medium'
export default icon
